import script from "./ControlBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ControlBar.vue?vue&type=script&setup=true&lang=ts"

import "./ControlBar.vue?vue&type=style&index=0&id=be6bebb2&scoped=true&lang=css"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be6bebb2"],['__file',"ControlBar.vue"]])

export default __exports__